import React from 'react';

function HomeIcon() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="13"
      height="17"
      fill="none"
      viewBox="0 0 13 17"
    >
      <g clipPath="url(#clip0_801_2953)">
        <g>
          <path
            fill="#FF8A00"
            d="M9.728 16.3H3.272C1.503 16.3 0 14.845 0 12.936v-6c0-.909.354-1.727.973-2.363l3.272-3.364c1.238-1.273 3.36-1.273 4.599 0l3.272 3.364c.619.636.972 1.454.972 2.363v6C13 14.846 11.497 16.3 9.728 16.3zM6.456 2.118c-.354 0-.708.182-.973.455L2.211 5.936c-.265.273-.442.637-.442 1v6c0 .818.707 1.546 1.503 1.546h6.456c.796 0 1.503-.728 1.503-1.546v-6c0-.363-.177-.818-.442-1.09L7.517 2.572a1.445 1.445 0 00-1.061-.455z"
          ></path>
        </g>
      </g>
      <defs>
        <clipPath id="clip0_801_2953">
          <path
            fill="#fff"
            d="M0 0H13V16H0z"
            transform="translate(0 .3)"
          ></path>
        </clipPath>
      </defs>
    </svg>
  );
}

export default HomeIcon;
